import { render, staticRenderFns } from "./SchemaPreviewJson.vue?vue&type=template&id=73aae99a&scoped=true&"
import script from "./SchemaPreviewJson.vue?vue&type=script&lang=js&"
export * from "./SchemaPreviewJson.vue?vue&type=script&lang=js&"
import style0 from "./SchemaPreviewJson.vue?vue&type=style&index=0&id=73aae99a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aae99a",
  null
  
)

export default component.exports